<div
  class="modal-container saved-carts-list-modal-container restore"
  [ngClass]="deviceDetectorService.isMobile() ? 'reorderMobile' : ''"
>
  <div class="modal-content">
    <div class="modal-header d-flex align-items-center">
      @if (!reorder) {
      <h4 class="modal-title">{{ 'cart.savedCartsModal.title' | cxTranslate }}</h4>
      } @if (reorder) {
      <h4 class="modal-title">{{ 'cart.reorder.title' | cxTranslate }}</h4>
      }
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal('Cross click')"
        [disabled]="restoreInprogress"
      >
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>

    <form novalidate [formGroup]="restoreCartModalForm">
      <div class="modal-body">
        @if (!reorder && checkIsMobileAndNoActiveCart()) {
        <h3>{{ 'cart.savedCartsModal.subtitle' | cxTranslate }}</h3>
        } @if (activeCartCount > 0 && reorder) {
        <h3>
          {{ 'cart.reorder.subtitle' | cxTranslate }}
        </h3>
        } @if (!reorder) {
        <p>
          {{ 'cart.savedCartsModal.desc' | cxTranslate }}
        </p>
        } @if (activeCartCount > 0 && reorder) {
        <p>
          {{ 'cart.reorder.desc' | cxTranslate }}
        </p>
        } @else { @if (reorder) {
        <p [innerHTML]="'cart.reorder.descNonActive' | cxTranslate : { orderNo: cartId }"></p>
        } } @if (activeCartCount > 0 && reorder) {
        <div class="cart-details-container d-flex flex-row flex-wrap">
          <span class="attribute">{{ 'cart.savedCartsModal.attrs.name' | cxTranslate }}</span>
          <span class="value text-break">{{ cartName }}</span>
          <span class="attribute">{{ 'cart.savedCartsModal.attrs.id' | cxTranslate }}</span>
          <span class="value">{{ cartId }}</span>
          @if (cartTotalItems) {
          <span class="attribute">{{ 'cart.savedCartsModal.attrs.number' | cxTranslate }}</span>
          } @if (cartTotalItems) {
          <span class="value">{{ cartTotalItems }}</span>
          }
        </div>
        } @if (!reorder) {
        <div class="cart-details-container d-flex flex-row flex-wrap">
          <span class="attribute">{{ 'cart.savedCartsModal.attrs.name' | cxTranslate }}</span>
          <span class="value text-break">{{ cartName }}</span>
          <span class="attribute">{{ 'cart.savedCartsModal.attrs.id' | cxTranslate }}</span>
          <span class="value">{{ cartId }}</span>
          @if (cartTotalItems) {
          <span class="attribute">{{ 'cart.savedCartsModal.attrs.number' | cxTranslate }}</span>
          } @if (cartTotalItems) {
          <span class="value">{{ cartTotalItems }}</span>
          }
        </div>
        } @if (activeCartCount > 0) {
        <div class="cart-details-container-has-active-cart">
          <p [innerHTML]="'cart.savedCartsModal.activeCart.desc' | cxTranslate"></p>
          <div class="cart-details-container-confirm-save">
            <mat-checkbox [disableRipple]="true" formControlName="confirmSave" [color]="'primary'">
              {{ 'cart.savedCartsModal.activeCart.checkbox' | cxTranslate }}
            </mat-checkbox>
            @if (restoreCartModalForm.value.confirmSave) {
            <p>
              {{ 'cart.savedCartsModal.activeCart.inputLabel' | cxTranslate }}
            </p>
            } @if (restoreCartModalForm.value.confirmSave) {
            <mat-form-field appearance="outline" class="w-100 mt-3">
              <mat-label>{{ 'cart.savedCartsModal.activeCart.inputPlaceholders' | cxTranslate }}</mat-label>
              <input
                #cartName
                matInput
                [placeholder]="'cart.savedCartsModal.activeCart.inputPlaceholders' | cxTranslate"
                formControlName="cartNameInput"
                maxlength="255"
              />
            </mat-form-field>
            }
          </div>
        </div>
        }
      </div>
      <div
        class="modal-footer justify-content-sm-between justify-content-md-end"
        [class.modal-footer-cart-exists]="activeCartCount > 0 && reorder"
      >
        <button type="button" class="btn secondary-btn" (click)="closeModal('Cross click')">
          {{ 'cart.savedCartsModal.cancel' | cxTranslate }}
        </button>
        <button
          type="button"
          class="btn primary-btn"
          (click)="onRestoreSavedCart(cartTotalItems)"
          [class.nl-button]="customizeModalButtons(activeLanguage$ | async, reorder)"
          [class.disabled]="!restoreCartModalForm?.valid || restoreInprogress"
          [disabled]="!restoreCartModalForm?.valid || restoreInprogress"
          [ngClass]="{ rotating: restoreInprogress }"
        >
          @if (!restoreInprogress) { @if (!reorder) {
          {{ 'cart.savedCartsModal.restore' | cxTranslate }}
          } @if (reorder) {
          {{ 'cart.savedCartsModal.reorder' | cxTranslate }}
          } }
        </button>
      </div>
    </form>
  </div>
</div>
